/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

import HorizontalSpacing from 'bundles/browse-common/components/HorizontalSpacing';
import RoleCitation from 'bundles/browse-common/components/RoleCitation';
import SkillBreadcrumbsComponent from 'bundles/browse-common/components/SkillBreadcrumbsComponent';
import ValuePropositionMetatags from 'bundles/browse-common/components/ValuePropositionMetatags';
import { useSkillEntity } from 'bundles/browse-common/contexts/SkillEntityContext';
import BrowsePageConfigComponentRenderer from 'bundles/browse-common/renderers/BrowsePageConfigComponentRenderer';
import { useComponentsConfig } from 'bundles/page-config-common/contexts/ComponentsConfigContext';

const styles = {
  root: css`
    margin-top: var(--cds-spacing-200);
    ${breakpoints.down('sm')} {
      margin-top: var(--cds-spacing-100);
    }
  `,
  breadcrumbs: css`
    margin-bottom: var(--cds-spacing-400);
    ${breakpoints.down('sm')} {
      margin-bottom: var(--cds-spacing-200);
    }
  `,
};

const SkillPageRootContent = () => {
  const pageConfigComponents = useComponentsConfig()?.filter(Boolean) ?? [];

  const skillEntity = useSkillEntity();

  return (
    <div css={styles.root}>
      {skillEntity && (
        <div css={styles.breadcrumbs}>
          <HorizontalSpacing>
            <SkillBreadcrumbsComponent entity={skillEntity} />
          </HorizontalSpacing>
        </div>
      )}
      <BrowsePageConfigComponentRenderer pageConfigComponents={pageConfigComponents} />
      {pageConfigComponents.some((component) => component.__typename === 'PageConfig_ExploreRolesComponent') && (
        <RoleCitation />
      )}
      <ValuePropositionMetatags />
    </div>
  );
};

export default SkillPageRootContent;
